module.exports = __webpack_public_path__ + "img/it-88.bed218a4.svg";